import { Object3D, Group } from 'three';

export default class FloatingBall {
    constructor(mesh, GAME) {

        this.mesh = mesh;
        this.scale = 3;
        this.object = new Object3D();
        this.GAME = GAME;

        this.init();
    }

    init() {

        this.mesh.scene.traverse((child) => {
            if (child.isMesh && child.material.map) {
                child.material.map.anisotropy = this.GAME.renderer.capabilities.getMaxAnisotropy();
                child.material.needsUpdate = true;
                if (this.GAME.config.shadows) {
                    child.castShadow = true;
                    child.receiveShadow = true;
                } else {
                    child.castShadow = false;
                    child.receiveShadow = false;
                }
            }
        });

        this.mesh.scene.rotation.set(Math.PI / -2, 0, 0);
        this.group = new Group();
        this.group.add(this.mesh.scene);
        this.group.scale.set(this.scale, this.scale, this.scale);

        this.GAME.scene.add(this.group);
        this.group.add(this.object);
        this.mesh.scene.position.set(0, 0, this.GAME.config.ball.height * .86);
        this.tickHandler = () => {
            this.group.rotation.y += 0.01;
            // animate the ball up and down between 1 and 2
            this.group.position.y = 2 + Math.sin(this.GAME.TIME.elapsed * 0.004) * 0.1;
        };

        this.GAME.TIME.addEventListener('tick', this.tickHandler);

    }

}